import { useMemo, useState, useEffect } from "react";
import Api from "../Services/Api";
import FormularioList from "./FormularioList";
import FormularioInput from "./FormularioInput";
import FormularioButom from "./FormularioButom";

const FormularioPedidoOmie = ({ licenciados = [], pedido, onClose, onAtualizado, onReload }) => {
  const [loading, setLoading] = useState(false);

  // campos editáveis
  const [licensed_id, setLicensedId] = useState("");
  const [commission_percent, setCommissionPercent] = useState("");
  const [status, setStatus] = useState("PENDING");

  useEffect(() => {
    if (!pedido) return;
    setLicensedId(pedido.licenciado_id ? String(pedido.licenciado_id) : "");
    setCommissionPercent(pedido.percentual == null ? "" : String(pedido.percentual));
    setStatus(pedido.status || "PENDING");
  }, [pedido]);

  const listaLicenciados = useMemo(() => {
    return (licenciados || []).map((l) => ({
      label: l.name,           // no seu FormularioComissao você usa l.name :contentReference[oaicite:5]{index=5}
      value: String(l.id),
    }));
  }, [licenciados]);

  const listaStatus = useMemo(
    () => [
      { label: "Pendente", value: "PENDING" },
      { label: "Aguardando confirmação", value: "AWAITING_CONFIRMATION" },
      { label: "Confirmado", value: "CONFIRMED" },
      { label: "Cancelado", value: "CANCELLED" },
    ],
    []
  );

  const validar = () => {
    if (!licensed_id) return "Selecione o licenciado.";
    const cp = Number(commission_percent);
    if (!commission_percent || !Number.isFinite(cp) || cp <= 0) return "Informe um % de comissão válido.";
    if (!status) return "Selecione o status.";
    return null;
  };

  const salvar = async (e) => {
    e.preventDefault();
    const erro = validar();
    if (erro) return alert(erro);

    try {
      setLoading(true);
      const { data } = await Api.patch(`/omie/orders/${pedido.id}`, {
        licensed_id: Number(licensed_id),
        commission_percent: Number(commission_percent),
        status,
      });

      // atualiza a linha na tabela (sem refetch obrigatório)
      onAtualizado?.({
        ...pedido,
        licenciado_id: data.licensed_id ?? Number(licensed_id),
        percentual: data.commission_percent ?? Number(commission_percent),
        valor_comissao: data.commission_value ?? pedido.valor_comissao,
        status: data.status ?? status,
      });

      alert("Pedido atualizado ✅");
    } catch (err) {
      alert(err?.response?.data?.message || "Erro ao salvar pedido Omie.");
    } finally {
      setLoading(false);
    }
  };

  const confirmarEGerar = async () => {
    const erro = validar();
    if (erro) return alert(erro);

    try {
      setLoading(true);

      // 1) garante que o vínculo/%/status estão salvos
      await Api.patch(`/omie/orders/${pedido.id}`, {
        licensed_id: Number(licensed_id),
        commission_percent: Number(commission_percent),
        status,
      });

      // 2) confirma (backend gera o lançamento no ledger e marca CONFIRMED)
      await Api.post(`/omie/orders/${pedido.id}/confirm`);

      alert("Confirmado e lançado no extrato ✅");

      // Melhor: recarregar tudo (porque agora entrou um item novo no LEDGER e pode mudar ordem)
      onReload?.();
      onClose?.();
    } catch (err) {
      alert(err?.response?.data?.message || "Erro ao confirmar/gerar lançamento.");
    } finally {
      setLoading(false);
    }
  };

  if (!pedido) return null;

  const valorCompra = Number(pedido.valor_compra || 0);
  const cp = Number(commission_percent || 0);
  const valorPrevisto = cp > 0 ? (valorCompra * cp) / 100 : 0;

  return (
    <section className="card-comissao">
      <div className="card-header-comissao">
        <div>
          <div className="card-title">Pedido Omie</div>
          <div className="card-subtitle">
            Vincule ao licenciado e confirme para gerar o lançamento no extrato.
          </div>
        </div>
      </div>

      <form className="lancamentoForm" noValidate onSubmit={salvar}>
        {/* infos do pedido (somente leitura) */}
        <FormularioInput
          type="text"
          size="quarto"
          title="Cliente"
          id="omie_cliente"
          valor={pedido.cliente || ""}
          readOnly
          aoAlterado={() => {}}
        />

        <FormularioInput
          type="text"
          size="quarto"
          title="Nº do pedido"
          id="omie_numero"
          valor={pedido.numero || ""}
          readOnly
          aoAlterado={() => {}}
        />

        <FormularioInput
          type="number"
          size="quarto"
          title="Valor da compra (R$)"
          id="omie_valor"
          valor={String(valorCompra)}
          readOnly
          aoAlterado={() => {}}
        />

        {/* vínculo */}
        <FormularioList
          itens={listaLicenciados}
          title="Licenciado"
          required="required"
          id="licensed_id"
          helper="Selecione o licenciado"
          valor={licensed_id}
          aoAlterado={(v) => setLicensedId(v)}
        />

        <FormularioInput
          type="number"
          size="quarto"
          title="Percentual de comissão (%)"
          required="required"
          id="commission_percent"
          placeholder="Ex: 18"
          helper={`Comissão prevista: R$ ${valorPrevisto.toFixed(2)}`}
          valor={commission_percent}
          aoAlterado={(v) => setCommissionPercent(v)}
        />

        <FormularioList
          itens={listaStatus}
          title="Status"
          required="required"
          id="status"
          helper="Defina o status do pedido"
          valor={status}
          aoAlterado={(v) => setStatus(v)}
        />

        <div style={{ display: "flex", gap: 10 }}>
          <FormularioButom icone="💾" disabled={loading}>
            Salvar
          </FormularioButom>

          <button
            type="button"
            className="btn-secondary"
            onClick={confirmarEGerar}
            disabled={loading}
            title="Confirma e gera lançamento no extrato do licenciado"
          >
            ✅ Confirmar e gerar extrato
          </button>
        </div>
      </form>
    </section>
  );
};

export default FormularioPedidoOmie;
